import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import {
  assignCodeProposal,
  attachChart,
  attachUser,
  backFolder,
  changeFolder,
  changePassword,
  changeUserRole,
  cloneDash,
  codeSearch,
  setFolderLabel,
  getLineCounts,
  mapFile,
  getFunctionCallees,
  getFeatureSlice,
  getReverseSlice,
  loadFileGraph,
  indexRepoBackground,
  pollIndexStatus,
  expandNetworkFile,
  expandNetworkFunction,
  expandNetworkCallers,
  expandNetworkSlice,
  showNetworkCode,
  loadGraphSettings,
  saveGraphSettings,
  commitRepo,
  createApiCall,
  createAutoLine,
  createAutomation,
  createBookmark,
  createChart,
  createChartAboveChart,
  createDash,
  createDashAndAssignToMeasurable,
  createDataTable,
  createDataTableColumn,
  createDataTableRow,
  createFactotum,
  createFactotumState,
  createFactotumStateTie,
  createFolder,
  createHost,
  createNavigation,
  createParameter,
  createProject,
  createProjectTask,
  createProjectTaskInput,
  createRepo,
  createRepoFile,
  createRepoFileWithContent,
  createRepoFolder,
  createRole,
  createScenario,
  createScenarioMeasurable,
  createUser,
  createUserInOrg,
  createUserWithOrg,
  createWorkspace,
  deleteChart,
  deleteDash,
  deleteFile,
  deleteFolder,
  deleteProjectTaskInput,
  deleteWorkspace,
  detachUser,
  executeApiCall,
  executeChartCode,
  fileList,
  finalizeReset,
  //getDocumentImagePreview,
  getAutoLines,
  getAutomations,
  getCodeComments,
  getCodeProposals,
  getDashes,
  getFactotumStateTies,
  getFactotumStates,
  getFactotums,
  getFolders,
  getHosts,
  getOrganizationUsers,
  getOrganizations,
  getProjectTask,
  getProjectTasks,
  getProjects,
  getRepos,
  getRoles,
  getScenarioMeasurables,
  getUsersInRole,
  getWorkspace,
  getWorkspaceSummary,
  getWorkspaceSummarySearch,
  getWorkspaces,
  gitInfo,
  linkDashToRole,
  linkFolderToRole,
  linkRole,
  loadIdeState,
  login,  
  moveDash,
  openFile,
  pullRepo,
  pushRepo,
  renameFile,
  reset,
  resetHostPassword,
  runAutomation,
  saveIdeState,
  setEditingDash,
  setEditingDataTable,
  setOrganization,
  setPageNo,
  setWorkspace,
  switchCharts,
  toggleProjectTaskInput,
  //undeleteDocumentTemplate,
  unlinkRole,
  updateApiCall,
  updateAutoLine,
  updateAutomation,
  updateChart,
  updateChartCode,
  updateDash,
  updateDashFile,
  updateFactotum,
  updateFactotumState,
  updateHost,
  updateProject,
  updateProjectTask,
  updateProjectTaskInput,
  updateScenario,
  updateScenarioMeasurable,
  //uploadDocumentElementImage,
} from "./actions";
import type { AppDispatch, RootState } from "./store";

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

const useActions = () => {
  const dispatch = useDispatch();
  return bindActionCreators(
    {
      login,
      reset,
      finalizeReset,
      changePassword,
      getOrganizations,
      setOrganization,
      getOrganizationUsers,
      getWorkspace,
      getWorkspaces,
      getWorkspaceSummary,
      getWorkspaceSummarySearch,
      setWorkspace,
      createWorkspace,
      deleteWorkspace,
      attachUser,
      createUser,
      createUserInOrg,
      createUserWithOrg,
      detachUser,
      changeUserRole,
      getAutoLines,
      updateAutoLine,
      getAutomations,
      runAutomation,
      assignCodeProposal,
      getCodeComments,
      getCodeProposals,
      getDashes,
      getFolders,
      getHosts,
  getFactotums,
  getFactotumStates,
  getFactotumStateTies,
      getProjects,
      getProjectTask,
      getProjectTasks,
      getRoles,
      getRepos,
      getScenarioMeasurables,
      getUsersInRole,
      createDash,
      createDashAndAssignToMeasurable,
      updateDash,
      updateDashFile,
      createFolder,
      changeFolder,
      backFolder,
      createRole,
      createRepo,
      createScenario,
      createScenarioMeasurable,
      updateScenario,
      updateScenarioMeasurable,
      createHost,
      updateHost,
      resetHostPassword,
      createFactotum,
      updateFactotum,
      updateFactotumState,
      createFactotumState,
      createFactotumStateTie,
      createProject,
      createProjectTask,
      createProjectTaskInput,
      deleteProjectTaskInput,
      toggleProjectTaskInput,
      updateProject,
      updateProjectTask,
      updateProjectTaskInput,
      createAutomation,
      updateAutomation,
      createAutoLine,
      createBookmark,
      pullRepo,
      commitRepo,
      pushRepo,
      fileList,
      codeSearch,
      setFolderLabel,
      getLineCounts,
      mapFile,
      getFunctionCallees,
      getFeatureSlice,
      getReverseSlice,
      loadFileGraph,
      indexRepoBackground,
      pollIndexStatus,
      expandNetworkFile,
      expandNetworkFunction,
      expandNetworkCallers,
      expandNetworkSlice,
      showNetworkCode,
      loadGraphSettings,
      saveGraphSettings,
      gitInfo,
      openFile,
      deleteFile,
      renameFile,
      createRepoFile,
      createRepoFileWithContent,
      createRepoFolder,
      linkRole,
      unlinkRole,
      linkDashToRole,
      linkFolderToRole,
      setEditingDash,
      setEditingDataTable,
      //getDocumentImagePreview,
      deleteDash,
      deleteFolder,
      createChart,
      attachChart,
      deleteChart,
      updateChart,
      updateChartCode,
      executeChartCode,
      createChartAboveChart,
      switchCharts,
      cloneDash,
      moveDash,
      createApiCall,
      executeApiCall,
      updateApiCall,
      createDataTable,
      createDataTableColumn,
      createDataTableRow,
      createNavigation,
      createParameter,
      setPageNo,
      saveIdeState,
      loadIdeState,
    },
    dispatch
  );
};

export default useActions;
